import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Config from '../../../config/config';
import { refreshAccessToken } from '../../Authorization/authSlice';

const serverPath = Config.serverPath;
//
//CLEAR HISTORY
export const clearHistory = createAsyncThunk(
    "account/clearHistory", async(item, thunkApi) => {
        console.log(item);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/clearhistory/";
        const urlToFetch = `${url}${item.user_id}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                user_id: item.user_id,
                //main_name: item.main_name
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(clearHistory(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }  
        
        } else {
           // console.log(response);
            console.log('BAD clear history');
            return response.status;
        }

    }
);
//



// GET AVATAR by user id and name file avatar
/*export const getAvatar = createAsyncThunk(
    "account/getAvatar", async(user_id, avatar_name) => {

       
        const url = `${serverPath}/api/avatar/`;
        const urlToFetch = `${url}${user_id}/${avatar_name}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        if (response.ok) {
            console.log("Успех get AVATAR");
        } else {
           
           console.log('BAD get AVATAR');
         return response.status;
         }
        }
    );*/

    // GET AVATAR by user id  REFRESH LOGIN
/*export const getAvatarRefreshLogin = createAsyncThunk(
    "account/getAvatarRefreshLogin", async(user_id) => {

       console.log(user_id);
        const url = `${serverPath}/api/avatarforrl/`;
        const urlToFetch = `${url}${user_id}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
                     credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        if (response.ok) {
            console.log("Успех get AVATAR for refresh login");
        } else {
           
           console.log('BAD get AVATAR for refresh login');
         return response.status;
         }
        }
    );*/

//INITIAL STATE BEGINNING
const initialState ={ 
    openClearHistoryForm: false,
    openDeleteAvatarForm: false,
    errorAvatarValidateType: '',
    errorAvatarValidateSize: '',
    //avatarName: '',
};



const options = {
    name: 'account',
    initialState: {
        
        openClearHistoryForm: false,
        openDeleteAvatarForm: false,
        errorAvatarValidateType: '',
        errorAvatarValidateSize: '',
       // avatarPath: ``,
        //avatarName: '',
   
    },
    reducers: {
         // GET first INITIAL STATE
         getInitialStateAccount: state  => 
         initialState,
        openClearHistoryForm: (state) => {
            state.openClearHistoryForm = true;
        },
        closeClearHistoryForm: (state) => {
            state.openClearHistoryForm = false;
        },
        openDeleteAvatarForm: (state) => {
            state.openDeleteAvatarForm = true;
        },
        closeDeleteAvatarForm: (state) => {
            state.openDeleteAvatarForm = false;
        },
        validateAvatarImageType: (state, action) => {
            if (!action.payload) {
                state.errorAvatarValidateType ='Неправильный формат изображения. Допустимые форматы -jpg, jpeg, gif, png, webp.';
            } else {
                state.errorAvatarValidateType = '';
            }
           
        },
        validateAvatarImageSize: (state, action) => {
            if (!action.payload) {
                state.errorAvatarValidateSize = 'Слишком большой файл. Допустимый размер файла 500Кб';
            } else {
                state.errorAvatarValidateSize = '';
            }
           
        },
        clearErrorAvatarMessages: (state) => {
            state.errorAvatarValidateType = '';
            state.errorAvatarValidateSize = '';
        },


    },
    extraReducers(builder) {
        builder
        //clear History
        .addCase(clearHistory.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(clearHistory.fulfilled, (state, action) => {
         
            state.isFetching = true;
            state.error= false;
        })
        .addCase(clearHistory.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })


         //get avatar
         /*.addCase(getAvatar.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
            state.userMessage = 'Загрузка...';
        })
        .addCase(getAvatar.fulfilled, (state, action) => {
            //console.log(action.payload);
            state.isFetching = true;
            state.error = false;
           // state.avatarPath = action.payload.path;
        })
        .addCase(getAvatar.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
        })*/

      /*  //get avatar fore refresh login
        .addCase(getAvatarRefreshLogin.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
            state.userMessage = 'Загрузка...';
        })
        .addCase(getAvatarRefreshLogin.fulfilled, (state, action) => {
            console.log(action.payload);
            state.isFetching = true;
            state.error = false;
            state.avatarName = action.payload;
        })
        .addCase(getAvatarRefreshLogin.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
        })*/
    }
}
export const accountSlice = createSlice(options);
export const { openClearHistoryForm, closeClearHistoryForm, getInitialStateAccount, openDeleteAvatarForm, closeDeleteAvatarForm, clearErrorAvatarMessages, validateAvatarImageType, validateAvatarImageSize } = accountSlice.actions;
export default accountSlice.reducer;